module.exports = {
    openItem: window.__shell.openItem,
    showItemInFolder: window.__shell.showItemInFolder
}